import React from 'react';

import { Link } from 'react-router-dom';

import Bingoly from '@/assets/images/Olybet/bingoly.svg';

import { RoutesEnum } from '@/enums/routes.enum';

const SidebarTop = () => {
  return (
    <div>
      <Link style={{ width: '177px', height: '54px' }} to={RoutesEnum.play}>
        <img alt="logo" src={Bingoly} />
      </Link>
    </div>
  );
};

export default SidebarTop;
